import { useState, useEffect } from 'react';
import {
  Grid,
  Container,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
  Divider,
  CardContent,
  Card,
  Avatar,
} from '@mui/material';

// components
import Page from '../components/Page';
// sections

import { faker } from '@faker-js/faker';
// @mui
import { useTheme } from '@mui/material/styles';
import Iconify from '../components/Iconify';
import useDashboard from 'src/api/useDashboard';
import EmpProductivity from './EmpProductivity';
import HeadCountDashboard from './HeadCountDashboard';
import { getClientLocations } from 'src/api/ShiftMaster';

import {
  AppTasks,
  AppNewsUpdate,
  AppOrderTimeline,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppTrafficBySite,
  AppWidgetSummary,
  AppCurrentSubject,
  AppConversionRates,
} from '../sections/@dashboard/app';
import { format,addDays, parseISO } from 'date-fns';
import { Navigate, useNavigate } from 'react-router-dom';
import axios from '../axios';
import { getURL } from 'src/utils/config';
import { handleResponse } from 'src/utils/responseHandler';
import dayjs from 'dayjs';
import {
  LineChart,
  Line,CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,Area,
  Legend,
  ResponsiveContainer,
} from 'recharts';
// ----------------------------------------------------------------------
import { motion, AnimatePresence, color } from 'framer-motion';

import { getChartCount } from 'src/api/clientDetails';

Object.defineProperty(String.prototype, 'capitalize', {
  value: function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false,
});

const cc = ['primary', 'secondary', 'info', 'success', 'warning'];

export default function DashboardApp({ clientId, userType }) {

  clientId = clientId || localStorage.getItem('client_id');
  userType = userType || localStorage.getItem('user_type');

  const formatEventTime = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return format(new Date(dateString), 'MMM-dd-yyyy hh:mm a');
    } catch (error) {
      return 'Invalid Date';
    }
  };

  const [analytics,setAnalytics] = useState([])
  const [location, setLocation] = useState(() => {
    const stored = localStorage.getItem('selectedLocation');
    return stored ? parseInt(stored) : null;
  });

  const [timeRange, setTimeRange] = useState('1'); // Default: Last 7 Days
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [isAllZero, setIsAllZero] = useState(false);



  

  const navigate = useNavigate();
  const [chartData, setChartData] = useState([]);

  // useEffect(()=>{
  //   const location =localStorage.getItem('selectedLocation') 
  //    let bodyLimit = {
  //       limit: 3,
  //       location_id:Number(location)
  //     };
  //     getClientAudits(bodyLimit, (auditResponse) => {
  //       if (auditResponse.status === 200 && auditResponse.data.length > 0) {
  //         setRecentEvents(auditResponse.data);
  //       }
  //     });

  //      getClientCameras(clientId.toString(),(res)=>{
  //       if(res.status===200){        
  //         const activeCameras = res.data.filter((camera) => camera.Status === 1).length;
  //         const inactiveCameras = res.data.filter((camera) => camera.Status === 0).length;
  //          setCameraInfo({
  //           active:activeCameras,
  //           inactive:inactiveCameras
  //          })
  //       }
  //   })

  //     console.log(dateRange)

  //     // const body = {
  //     //     fromdate: dayjs(newFromDate).format('YYYY-MM-DD HH:mm:ss'),
  //     //     todate: dayjs(toDate).format('YYYY-MM-DD HH:mm:ss'),
  //     // };

  //     // getCameraCount(body, (res) => {
  //     //     if (res.status === 200 && res.data.length > 0) {
  //     //       setTopCamerasInfo(res.data);
  //     //     }
  //     // });

  // },[timeRange])
  

  useEffect(() =>{
  const type =
    timeRange === '7'
      ? '7days'
      : timeRange === '30'
      ? '30days'
      : timeRange === '1'
      ? '24hours'
      : '';
  if(location === 11){  
    const chartData = {
      type:type
    }

  getChartCount(chartData, (res) => {
    if (res.status === 200 && res.data && res.data.previous && res.data.current) {
      let formattedData = [];
      if (timeRange === '1') {
       
        formattedData = res.data.current.map((curr) => {
          const currTime = dayjs(curr.day).format('HH:mm');        
          const prevData = res.data.previous.find(
            (prev) => dayjs(prev.day).format('HH:mm:ss') === dayjs(curr.day).format('HH:mm:ss')
          ) || { count: 0 };
          return {
            name: currTime + ' hr',
            Previous: prevData.count,
            Current: curr.count,
          };
          
        });
      } else if (timeRange === '7') {
        //const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        formattedData = res.data.previous.map((prev, index) => ({
          name: prev.day, 
          Previous: prev.count,
          Current: res.data.current[index].count,
        }));
                  

      } else if (timeRange === '30') {
        formattedData = res.data.current.map((curr, index) => {
          const currDate = dayjs(curr.day).format('MM-DD');
          const prevData = res.data.previous.find(
            (prev) => dayjs(prev.day).format('MM-DD') === currDate
          ) || { count: 0 };
          return {
            name: currDate,
            Previous: prevData.count,
            Current: curr.count,
          };
        });
      } 
    
      const allNonZero = (data) => {
       return data.every(item => item.Previous == 0 && item.Current == 0);
      };
      
      const result = allNonZero(formattedData)
      if(result){
       setIsAllZero(result);
        formattedData = formattedData.map((item, index) => ({
        ...item,
        Previous: 0.05, 
        Current: 0,
      }));
      }
       setChartData(formattedData);
    } else {
      console.error('Failed to fetch chart data or invalid data structure:', res);
      setChartData([]);
    }
  });
  }
  else{
  setChartData([]);
  }
  },[timeRange,location])

  useEffect(() => {

    const body = {client_id: Number(clientId)}

    getClientLocations(body, (response) => {
      if (response.status === 200) {
        setLocations(response.data);

        const stored = localStorage.getItem('selectedLocation');
        if (stored) {
          const found = response.data.find((loc) => loc.Id === parseInt(stored));
          if (found) {
            setLocation(found.Id);
            setSelectedLocation(found);
          }
        } else {
          const first = response.data[0];
          if (first) {
            setLocation(first.Id);
            setSelectedLocation(first);
            localStorage.setItem('selectedLocation', first.Id);
          }
        }
      }
    });

    const getAnalytics = () => {
            axios({
                method: 'get',
                url: getURL('analytics-sub/client-wise-analytics'),
                validateStatus: (status) => handleResponse(status),
            }).then(function (response) {
                if (response.status === 200) {
                  
                    setAnalytics([...response.data])
                }
            })
    }

    getAnalytics()

  }, []);

  const {
    recentEvents,
    alldata,
    //graph,
    getIcon,
    dateRange,
    filteredLocationInfo
  } = useDashboard({
    clientId,
    location: Number(clientId) === 1262 ? location : '',
    timeRange: Number(clientId) === 1262 ? timeRange : '1',
  });
 console.log('alldata',alldata)
  const showHeadCount =
    (Number(clientId) === 797 &&
      (Number(userType) === 30 || Number(userType) === 2 || Number(userType) === 7)) ||
    Number(clientId) === 691;

  const showFilters = Number(clientId) === 1262;
  const canShowDashboard =
    !showFilters || (showFilters && location && timeRange);
  const theme = useTheme();

  const handleWidgetClick = (eventType) => {
    
   console.log(selectedLocation)
    //console.log(analytics)
    //const today = new Date();
    //let fromDate, toDate;

    const locationName = selectedLocation.LocationName

    const fromDate = format(parseISO(dateRange.from), 'yyyy-MM-dd HH:mm:ss');
    const toDate = format(parseISO(dateRange.to), 'yyyy-MM-dd HH:mm:ss');

    let type = 0

    if(analytics.length>0){
      const analyticsItem = analytics.find((item) => item.Name.toLowerCase() === eventType.toLowerCase());
      type = analyticsItem ? analyticsItem.Id : 0;
    }

    eventType = type
    navigate('/audits', {
      state: {
        filterData: {
          eventType,
          fromDate,
          toDate,
          locationName
        },
      },
    });
  };

  const showData = ()=>{
    const fromDate = format(parseISO(dateRange.from), 'yyyy-MM-dd HH:mm:ss');
    const toDate = format(parseISO(dateRange.to), 'yyyy-MM-dd HH:mm:ss');
    const eventType = ''
    const locationName = selectedLocation.LocationName
    navigate('/audits', {
      state: {
        filterData: {
          eventType,
          fromDate,
          toDate,
          locationName
        },
      },
    });
  }

  const totalAuditsFromAlldata = (alldata?.data || [])
    .filter((item) => item.cunt !== 0)
    .reduce((sum, item) => sum + item.cunt, 0);

  const client_id = localStorage.getItem("client_id");

  const [count, setCount] = useState(20);

  useEffect(() => {
    const interval = setInterval(() => {
      const randomCount = Math.floor(Math.random() * 50) + 1;
      setCount(randomCount);
    }, 150000); // updates every 2 seconds

    return () => clearInterval(interval);
  }, []);






  //line chart dummy
//   const dataToday = [
//   { name: "04:39 hr", Previous: 0, Current: 2 },
//   { name: "06:39 hr", Previous: 0, Current: 0 },
//   { name: "08:39 hr", Previous: 0, Current: 0 },
//   { name: "10:39 hr", Previous: 0, Current: 0 },
//   { name: "12:39 hr", Previous: 0, Current: 0 },
//   { name: "14:39 hr", Previous: 0, Current: 0 },
//   { name: "16:39 hr", Previous: 0, Current: 0 },
//   { name: "18:39 hr", Previous: 0, Current: 2 },
//   { name: "20:39 hr", Previous: 0, Current: 0 },
//   { name: "22:39 hr", Previous: 0, Current: 0 },
//   { name: "00:39 hr", Previous: 0, Current: 0 },
//   { name: "02:39 hr", Previous: 0, Current: 0 },
// ];

// const dataWeek = [
//   { name: "Mon", Previous: 4, Current: 5 },
//   { name: "Tue", Previous: 2, Current: 3 },
//   { name: "Wed", Previous: 0, Current: 1 },
//   { name: "Thu", Previous: 1, Current: 0 },
//   { name: "Fri", Previous: 2, Current: 2 },
//   { name: "Sat", Previous: 1, Current: 3 },
//   { name: "Sun", Previous: 3, Current: 2 },
// ];

// const dataMonth = [
//   { name: "Day 0", Previous: 4, Current: 5 },
//   { name: "Day 5", Previous: 4, Current: 5 },
//   { name: "Day 10", Previous: 2, Current: 3 },
//   { name: "Day 15", Previous: 0, Current: 1 },
//   { name: "Day 20", Previous: 1, Current: 0 },
//   { name: "Day 25", Previous: 2, Current: 2 },
//   { name: "Day 30", Previous: 1, Current: 3 },
// ];

// const dataMonth1 = Array.from({ length: 30 }, (_, i) => ({
//   name: `Day ${i + 1}`,
//   Previous: Math.floor(Math.random() * 5),
//   Current: Math.floor(Math.random() * 5),
// }));



// const getChartData = () => {
//   switch (timeRange) {
//     case "7": return dataWeek;
//     case "30": return dataMonth;
//     case "1":
//     default: return dataToday;
//   }
// };

// const chartData = getChartData();

  return (
    <Page title="Dashboard">
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Dashboard
        </Typography>

        {showFilters && (
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel>Location</InputLabel>
                <Select
                  value={location || ''}
                  label="Location"
                  onChange={(e) => {
                    const val = e.target.value;
                    setLocation(val);
                    const locObj = locations.find((loc) => loc.Id === val);
                    setSelectedLocation(locObj);
                    localStorage.setItem('selectedLocation', val);
                  }}
                >
                  {locations.map((event) => (
                    <MenuItem key={event.Id} value={event.Id}>
                      {event.LocationName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel>Time Range</InputLabel>
                <Select
                  value={timeRange}
                  label="Time Range"
                  onChange={(e) => setTimeRange(e.target.value)}
                >
                  <MenuItem value="1">Today</MenuItem>
                  <MenuItem value="7">Last 7 Days</MenuItem>
                  <MenuItem value="30">Last 30 Days</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        )}

        <Grid container spacing={3}>
          {canShowDashboard ? (
            <Grid item xs={12}>
              <Grid container spacing={5}>
                {/* <Grid item xs={12} md={6} lg={4}>
                  {showHeadCount && <HeadCountDashboard />}
                  {Number(userType) !== 30 && alldata?.data && (
                    <AppConversionRates
                      title="Audits Track"
                      subheader={`Total Audits: ${totalAuditsFromAlldata}`}
                      chartData={(alldata?.data || [])
                        .filter((item) => item.cunt !== 0)
                        .map((item) => ({
                          label: item.Name.capitalize(),
                          value: item.cunt,
                        }))}
                    />
                  )}
                </Grid>
                <Grid item xs={12} md={6} lg={8}>
                  {Number(userType) !== 30 && (
                    <Grid container spacing={2}>
                      {(alldata?.data || []).map((row, key) => (
                        <Grid item xs={6} sm={6} md={3} key={key}>
                          <AppWidgetSummary
                            title={row.Name.capitalize()}
                            total={row.cunt}
                            color={cc[key] || 'primary'}
                            icon={getIcon(row.Name)}
                            onClick={row.cunt !== 0 ? () => handleWidgetClick(row.Name.capitalize()) : undefined}
                            sx={{
                              '& .icon': {
                                cursor: row.cunt !== 0 ? 'pointer' : 'default',
                              },
                            }}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </Grid> */}


                  <Grid item xs={12} md={12} lg={12}>
                    {Number(userType) !== 30 && (
                      <Grid container spacing={2}>
                        {(alldata?.data || []).map((row, key) => {
                          // Determine the icon name, handling the "false" case
                          const iconName = row.Name && row.Name.toLowerCase().replace(/\s+/g,'');
                          return (
                            <Grid item xs={6} sm={5} md={3} key={key}>
                              <AppWidgetSummary
                                title={typeof row.Name === "string" && row.Name[0]
                                  ? row.Name[0].toUpperCase() + row.Name.slice(1)
                                  : row.Name}
                                total={row.cunt}
                                color={cc[key] || 'primary'}
                                icon={getIcon(iconName)}
                                // onClick={row.cunt !== 0 ? () => handleWidgetClick(
                                //   typeof row.Name === "string" && row.Name[0]
                                //     ? row.Name[0].toUpperCase() + row.Name.slice(1)
                                //     : row.Name
                                // ) : undefined}
                                onClick={row.cunt !== 0 && iconName !== 'liveoccupancy'? () => handleWidgetClick(
                                  typeof row.Name === "string" && row.Name[0]
                                    ? row.Name[0].toUpperCase() + row.Name.slice(1)
                                    : row.Name
                                ) : undefined}
                                sx={{
                                  '& .icon': {
                                    cursor: row.cunt !== 0 ? 'pointer' : 'default',
                                  },
                                }}
                              />
                            </Grid>
                          );
                        })}
                      </Grid>

 
                    )}
                  </Grid>

                  {/* <Grid item xs={12} md={12} lg={12}>
                    {showHeadCount && <HeadCountDashboard />}
                    
                    {Number(userType) !== 30 && alldata?.data && (
                      // <AppConversionRates
                      //   title="Audits Track"
                      //   subheader={`Total Audits: ${totalAuditsFromAlldata}`}
                      //   chartData={(alldata?.data || [])
                      //     .filter((item) => item.cunt !== 0)
                      //     .map((item) => ({
                      //       label: item.Name.capitalize(),
                      //       value: item.cunt,
                      //     }))}
                      // />

                      <AppConversionRates
                        title="Violation Track"
                        subheader={`Total violations: ${totalAuditsFromAlldata}`}
                        chartData={(alldata?.data || [])
                          .filter(
                            (item) =>
                              item.cunt !== 0 &&
                              item.Name &&
                              item.Name.toLowerCase().replace(/\s+/g, '') !== 'liveoccupancy' 
                          )
                          .map((item) => ({
                            label: item.Name.capitalize(),
                            value: item.cunt,
                          }))}
                      />

                    )}
                  </Grid> */}
                    <Grid item xs={12} md={12} lg={12} mt={3} ml={5} mb={1} sx={{ backgroundColor: (theme) => theme.palette.background.paper, p: 2, borderRadius: 2 }}>
                          <Typography variant="h6" mb={2} color="primary.text">
                            Violation Trends
                          </Typography>
                      
                            <ResponsiveContainer width="100%" height={250}>
                              <LineChart data={chartData}>
                                <XAxis 
                                  dataKey="name" 
                                  stroke="#e0e0e0" // light gray for dark backgrounds
                                  tick={{ fill: "#e0e0e0" }} 
                                />
                                <YAxis
                                  domain={isAllZero ? [0, 5] : [0, dataMax => Math.ceil(dataMax)]}
                                  ticks={isAllZero ? [0, 1, 2, 3, 4, 5] : undefined}
                                  stroke="#e0e0e0"
                                  tick={{ fill: "#e0e0e0" }}
                                  tickFormatter={(value) => Math.floor(value).toString()}
                                  allowDecimals={false}
                                />
                                <Tooltip 
                                  contentStyle={{ backgroundColor: "#424242", border: "none", color: "#fff" }} 
                                  itemStyle={{ color: "#fff" }} 
                                  labelStyle={{ color: "#fff" }}
                                />
                                <Legend 
                                  wrapperStyle={{ color: "#e0e0e0" }} 
                                />
                                <Line type="monotone" dataKey="Previous" stroke="#EF5350" />
                                <Line type="monotone" dataKey="Current" stroke="#66BB6A" />
                              </LineChart>
                            </ResponsiveContainer>

                    </Grid>
       
                <Grid item xs={12} md={12} lg={12} mt={0}>
                  <Grid
                    container
                    spacing={3}
                    mt={4}
                    sx={{
                      display: 'flex',
                      alignItems: 'stretch', // Ensure Grid items stretch to the same height
                    }}
                  >

                    <Grid
                      item
                      xs={12}
                      md={6}
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        //minHeight: '400px', 
                      }}
                    >
                      <Grid container justifyContent="space-between" alignItems="center">
                        <Typography variant="h6" >Recent Events</Typography>
                        {/* <Button
                          onClick={showData}
                          variant="outlined"
                          size="small"
                        >
                          Show All
                        </Button> */}

                        <Button
                          onClick={showData}
                          variant="outlined"
                          size="small"
                          sx={{
                            color: '#FFFFFF', // white text
                            borderColor: '#FFFFFF', // white border
                            '&:hover': {
                              backgroundColor: 'rgba(255, 255, 255, 0.12)', // light white overlay on hover
                              borderColor: '#FFFFFF',
                            },
                          }}
                        >
                          Show All
                        </Button>


                      </Grid>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
                        {recentEvents.map((event, index) => (
                          <Card key={index} sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              width: '100%',
                              cursor: 'pointer',
                              '&:hover': { backgroundColor: 'gray' }
                            }}
                            onClick={() => navigate('/audits',{ state: { filterData: { event } } })}
                          >
                          {
                            client_id === "1262" ? (
                              <CardContent sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, width: '100%' }}>
                                <Avatar
                                  variant="rounded"
                                  src={event.SnapshotUrl}
                                  sx={{ width: 60, height: 60, flexShrink: 0 }}
                                />
                                <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
                                  <Typography variant="subtitle2" color="text.primary">
                                    {event.devicename}
                                  </Typography>
                                  <Typography variant="body2" sx={{ color: '#e0e0e0' }}>
                                    {event.DetectedType}
                                  </Typography>
                                  <Typography variant="caption" sx={{ color: '#b0bec5' }}>
                                    {event.EventTime ? formatEventTime(event.EventTime) : ''}
                                  </Typography>
                                </Box>
                                <Box
                                  sx={{
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    backgroundColor: event.type === 'Alert' ? 'red' : 'green',
                                    flexShrink: 0,
                                  }}
                                />
                              </CardContent>
                            ) : (
                              <CardContent sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, width: '100%' }}>
                                <Avatar
                                  variant="rounded"
                                  src={event.SnapshotUrl}
                                  sx={{ width: 60, height: 60, flexShrink: 0 }}
                                />
                                <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
                                  <Typography variant="subtitle2" color="text.primary">
                                    {event.devicename}
                                  </Typography>
                                  <Typography variant="body2" color="text.primary">
                                    {event.SupervisorComments}
                                  </Typography>
                                  <Typography variant="caption" color="text.primary">
                                    {dayjs(event.EventTime).format('YYYY-MM-DD HH:mm:ss')} | {event.EventType}
                                  </Typography>
                                </Box>
                                <Box
                                  sx={{
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    backgroundColor: event.type === 'Alert' ? 'red' : 'green',
                                    flexShrink: 0,
                                  }}
                                />
                              </CardContent>
                            )
                          }

                          </Card>
                        ))}
                      </Box>
                    </Grid>

    
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '400px', 
          }}
        >
          <Typography variant="h6">Location Information</Typography>
          <Card sx={{ mt: 2, flexGrow: 1 }}>
                  <CardContent
                    sx={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      p: 3,
                      borderRadius: 3,
                      background: (theme) => `linear-gradient(to right, ${theme.palette.background.paper})`,
                      boxShadow: 3,
                    }}
                  >
                    {filteredLocationInfo ? (
                      <>
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                            📍 Location: {filteredLocationInfo.LocationName}
                          </Typography>
                          <Typography variant="body1" sx={{ color: 'green', mt: 1 }}>
                            🟢 Online: {filteredLocationInfo.online}
                          </Typography>
                          <Typography variant="body1" sx={{ color: 'red', mt: 0.5 }}>
                            🔴 Offline: {filteredLocationInfo.offline}
                          </Typography>
                          <Typography variant="body2" sx={{ mt: 1.5, color: 'text.secondary' }}>
                            🏠 Address: {filteredLocationInfo.address}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            mt: 2,
                            p: 2,
                            backgroundColor: '#333666',
                            borderRadius: 2,
                            textAlign: 'center',
                            boxShadow: 1,
                          }}
                        >
                          <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                            Live Occupancy
                          </Typography>

                          <AnimatePresence mode="wait">
                            <motion.div
                              key={count}
                              initial={{ opacity: 0, y: -10 }}
                              animate={{ opacity: 1, y: 0 }}
                              exit={{ opacity: 0, y: 10 }}
                              transition={{ duration: 0.5 }}
                            >
                              <Typography
                                variant="h4"
                                sx={{
                                  fontWeight: 700,
                                  color: '#ffffff',
                                }}
                              >
                                {count}
                              </Typography>
                            </motion.div>
                          </AnimatePresence>
                        </Box>
                      </>
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        No location information available
                      </Typography>
                    )}
                  </CardContent>
                        </Card>
          {/* <Card sx={{ mt: 2, flexGrow: 1 }}>
            <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="body1" color="green">{cameraInfo.active} Online</Typography>
              <Typography variant="body1" color="red">{cameraInfo.inactive} Offline</Typography>
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle1">Cameras by Events</Typography>
              {topCameras.map((cam, idx) => (
                <Typography key={idx} variant="body2" sx={{ mt: 1 }}>
                  {cam.devicename} - {cam.count} Events
                </Typography>
              ))}
              <Box sx={{ mt: 'auto', pt: 2 }}>
                <Button variant="contained" color="primary" onClick={() => navigate('/live')}>
                  Go to Live Page
                </Button>
              </Box>
            </CardContent>
          </Card> */}
        </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          
          ) : (
            <Grid item xs={12}>
              <Typography variant="body1" color="text.secondary">
                Please select both location and time range to view dashboard.
              </Typography>
            </Grid>
          )}
        </Grid>
      </Container>
    </Page>
  );
}

